import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

const VideoModal = ({ video, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    
    // In tall iframes, we shouldn't lock body overflow as it might break parent scrolling
    const isInIframe = window.self !== window.top;
    if (!isInIframe) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }} 
      // Changed from items-center to items-start with pt-[5vh]
      // This ensures the modal is visible near the top of the iframe window
      // even if the iframe is 2000px tall.
      className="fixed inset-0 z-[9999] flex justify-center items-start pt-[5vh] pb-[5vh] px-4 bg-black/90 backdrop-blur-xl overflow-y-auto"
      onClick={onClose}
    >
      <motion.div 
        initial={{ scale: 0.9, opacity: 0, y: 40 }} 
        animate={{ scale: 1, opacity: 1, y: 0 }} 
        exit={{ scale: 0.9, opacity: 0, y: 40 }} 
        className="relative w-full max-w-5xl aspect-video bg-black rounded-2xl overflow-hidden border border-white/10 shadow-[0_0_100px_rgba(0,0,0,0.8)]" 
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 z-20 p-2 bg-black/60 backdrop-blur-md rounded-full text-white hover:bg-amber-500 hover:text-black transition-all duration-200"
        >
          <X className="w-6 h-6" />
        </button>

        {/* YouTube Embed */}
        <div className="w-full h-full">
          <iframe 
            src={`https://www.youtube.com/embed/${video.youtubeId}?autoplay=1&rel=0`} 
            title={video.title} 
            className="w-full h-full" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen 
          />
        </div>

        {/* Title Overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent pointer-events-none">
          <h3 className="text-white font-bold text-xl tracking-tight">{video.title}</h3>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default VideoModal;